// extracted by mini-css-extract-plugin
export default {"header":"styles_header__dLoxq","headerLink":"styles_headerLink__d0h5y","faqActive":"styles_faqActive__TqfCT","rColWrapper":"styles_rColWrapper__rNj0T"};